var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"micBox"}},[_c('div',{ref:"audioValBox",staticClass:"audioValBox",style:({background: _vm.background})},[_c('div',{ref:"level",staticClass:"level"})]),_c('p',{staticClass:"line"}),_c('div',{staticClass:"verticalDivider"}),_c('div',{staticClass:"footLine"})])
}
var staticRenderFns = []

export { render, staticRenderFns }